import {createRoot} from 'react-dom/client';
import apiFetch from '@wordpress/api-fetch';
import Router from './routes';
import {BrowserRouter} from "react-router-dom";
import {HelmetProvider} from 'react-helmet-async';
import ThemeProvider from './theme'
import NoticeProvider from "./contexts/NoticeContext";
import NoticeStackProvider from './components/NotistackProvider';
import {CollapseDrawerProvider} from "./contexts/CollapseDrawerContext";
import ScrollToTop from "./components/ScrollToTop";

// scroll bar
import 'simplebar/src/simplebar.css';

// lightbox
// import 'react-image-lightbox/style.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// editor
import 'react-quill/dist/quill.snow.css';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';
import ThemeSettings from "./components/settings";

// redux
import {Provider as ReduxProvider} from 'react-redux';
import store from './store';
import {AuthenticationProvider} from './contexts/authentication'
import {CustomerDataProvider} from "./contexts/CustomerDataContext";

import {QueryClientProvider, QueryClient} from "@tanstack/react-query";

const App = () => {
    apiFetch.use(apiFetch.createRootURLMiddleware('/v1/'));
    return (
        <QueryClientProvider client={new QueryClient()}>
            <ReduxProvider store={store}>
                <CustomerDataProvider>
                    <AuthenticationProvider provider={'cognito'}>
                        <HelmetProvider>
                            <CollapseDrawerProvider>
                                <BrowserRouter>
                                    <ThemeProvider>
                                        <ThemeSettings>
                                            <NoticeStackProvider>
                                                <NoticeProvider>
                                                    <Router>
                                                        <ScrollToTop/>
                                                    </Router>
                                                </NoticeProvider>
                                            </NoticeStackProvider>
                                        </ThemeSettings>
                                    </ThemeProvider>
                                </BrowserRouter>
                            </CollapseDrawerProvider>
                        </HelmetProvider>
                    </AuthenticationProvider>
                </CustomerDataProvider>
            </ReduxProvider>
        </QueryClientProvider>
    );
}

const root = createRoot(document.getElementById('app'));
root.render(<App/>);
